import { render, staticRenderFns } from "./TableOdontograma.vue?vue&type=template&id=724c198a"
import script from "./TableOdontograma.vue?vue&type=script&lang=js"
export * from "./TableOdontograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports